export default __webpack_public_path__ + "static/media/35.9e798054.png";